import getParentLoop from '../get-item-parent-loop';

/**
 * Determines if a given item is inside a user loop.
 *
 * @param {Number} itemID - The ID of the item to check.
 * @return {Boolean} Returns true if the item is inside a user loop, otherwise false.
 * @throws {Error} Throws an error if the itemID is not provided.
 */
const isItemInsideUserLoop = ( itemID ) => {
	// Get the parent loop
	const parentLoop = getParentLoop( itemID );

	return Boolean( parentLoop?.iterable_expression?.type === 'users' );
};

export default isItemInsideUserLoop;
